import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../../assets/style/BranchForm.css"; // Updated CSS file with USWDS grid
import {
  CustomSelect,
  getData,
  postData,
} from "../Commonfunction/CommonFunction";
import { toast } from "react-toastify";

// Validation schema using Yup
const validationSchema = Yup.object().shape({
  state_name: Yup.string().required("State is required"),
  rate: Yup.string().required("Rate is required"),
});

const StateForms = ({ onClose, id, fetchData }) => {
  const [singleData, setSingleData] = useState();
  const singleCountyData = async () => {
    try {
      const result = await getData(`/api/get-state/${id}`);
      if (result.success) {
        setSingleData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const handleSubmit = async (values) => {
    try {
      const request_url = id ? `/api/update-state/${id}` : "/api/create-state";
      const postDataResult = await postData(request_url, values);

      toast.success(postDataResult.message);
      // postDataResult?.success === true && navigate("/master/state");
      fetchData();
      onClose();
    } catch (error) {
      // Handle error
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    id && singleCountyData();
  }, [id]);

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          state_name: id ? singleData?.state_name : "",
          rate: id ? singleData?.rate : "4",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
          onClose();
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="form-body">
              <div className="grid-row">
                <div className="grid-col-6">
                  <div className="form-group">
                    <label htmlFor="state_name">State</label>
                    <Field
                      id="state_name"
                      name="state_name"
                      type="text"
                      placeholder="Enter State "
                      className={
                        errors.state_name && touched.state_name
                          ? "input-error"
                          : ""
                      }
                    />
                    <ErrorMessage
                      name="state_name"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>

                <div className="grid-col-6">
                  <div className="form-group">
                    <label htmlFor="rate">Rate</label>
                    <Field
                      id="rate"
                      name="rate"
                      type="text"
                      placeholder="Enter Rate"
                      className={
                        errors.rate && touched.rate ? "input-error" : ""
                      }
                    />
                    <ErrorMessage
                      name="rate"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-footer">
              <button
                type="button"
                className="btn btn-cancel"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-submit">
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default StateForms;
